import { Injectable } from '@angular/core';
import {CustomerNameModalPage} from "../../pages/customer-name-modal/customer-name-modal";
import {PopoverController} from "ionic-angular";

/*
  Generated class for the RegisterGuestServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RegisterGuestServiceProvider {

  constructor(private popoverCtrl: PopoverController) {

  }

  register(){
    return new Promise((resolve, reject) => {
      let modal = this.popoverCtrl.create(CustomerNameModalPage, {}, {
        cssClass: 'customer-name-modal',
        enableBackdropDismiss: false
      });
      modal.present();
      modal.onDidDismiss((user) => {
        if (user){
          resolve(user);
        } else {
          reject();
        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/register-guest-service/register-guest-service.ts